import { useState } from 'react'
import { useEffect } from 'react'

import {
  Checkbox,
  CheckboxGroup,
  Modal,
  ModalProvider,
  Option,
} from '@joor/design-system'
import { typography } from '@joor/design-system'
import styled from 'styled-components'

import { OrderStatus } from '__generated__/atlas-types'

import usePortal from 'hooks/usePortal'

import { useOrderId } from 'features/Orders/orders.hooks'

const StyledModal = styled(Modal)`
  // min-height: 350px;
`

/*const StyledDropdown = styled(Dropdown)`
  margin-bottom: 15px;
`
ALL THE COMMENTED CODE HERE will make sense in the future when we decide to use this modal in the order list.
When this was created the task was supposed to be about a component used in OR & order list 
but we found out we should define a clear logic of the moving statuses to another in the order list
before using this component there
*/

const Description = styled.div`
  ${typography.alpha.primaryActive.subtitle3}
  margin-bottom: 15px;
`

type ChangeStatusModalProps = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  status?: OrderStatus
  primaryBtnAction: any // TODO: type properly
  isLoading?: boolean
}

export const ChangeStatusModal = ({
  isOpen,
  setIsOpen,
  status,
  primaryBtnAction,
  isLoading = false,
}: ChangeStatusModalProps) => {
  const Portal = usePortal()
  const orderId = useOrderId()
  // const isRetailer = useSelector(isAccountTypeRetailer)
  const [isSentToBrand, setIsSentToBrand] = useState(true)
  const [isSentToRetailer, setIsSentToRetailer] = useState(true)
  const [selectedStatus, _setSelectedStatus] = useState<Option | undefined>(
    undefined,
  )
  const primaryButton = {
    text: 'Update',
    handler: async () => {
      await primaryBtnAction({
        orderIds: orderId,
        status,
        sendToBrand: isSentToBrand,
        sendToRetailer: isSentToRetailer,
      })
      setIsOpen(false)
    },
    loading: isLoading,
  }
  const formattedStatus =
    status?.length && status[0].toUpperCase() + status.slice(1).toLowerCase()

  useEffect(() => {
    if (status === 'SHIPPED') {
      setIsSentToBrand(false)
      return
    }
    setIsSentToRetailer(true)
    setIsSentToBrand(true)
  }, [status])

  /*
  const dropdownOptions = getDropdownOptions(isRetailer).map((option) => {
    return { label: option.text, value: option.code }
  })*/

  return (
    <Portal>
      <ModalProvider>
        <StyledModal
          title={{ text: 'Update Order Status' }}
          size={'small'}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        >
          <Modal.Content>
            {/*status ? (
              <Description>
                {`You are updating the status of this order to ${formattedStatus}.`}
              </Description>
            ) : (
              <StyledDropdown
                label="Select status"
                onSelect={({ selected }: { selected: Option }): void => {
                  setSelectedStatus(selected)
                }}
                options={dropdownOptions}
                placeholder="Status"
              />
              )*/}
            <Description>
              {`You are updating the status of this order to ${formattedStatus}.`}
            </Description>
            <CheckboxGroup label="Send confirmation to:">
              <Checkbox
                id="changeStatusModal_sentToBrand"
                label="Brand"
                onChange={() => setIsSentToBrand(!isSentToBrand)}
                checked={isSentToBrand}
                fontWeight="medium"
                disabled={
                  formattedStatus === 'Shipped' ||
                  (selectedStatus && selectedStatus.value === 'SHIPPED')
                }
              />
              <Checkbox
                id="changeStatusModal_sentToRetailer"
                label="Retailer"
                onChange={() => setIsSentToRetailer(!isSentToRetailer)}
                checked={isSentToRetailer}
                fontWeight="medium"
              />
            </CheckboxGroup>
          </Modal.Content>
          <Modal.Actions
            primaryButton={primaryButton}
            secondaryButtonText={'Cancel'}
          />
        </StyledModal>
      </ModalProvider>
    </Portal>
  )
}

export default ChangeStatusModal
